export function useTracking() {
  const { $api } = useNuxtApp();
  const route = useRoute();

  function trackEvent(category: string, action: string) {
    if (import.meta.server) return;

    // Strip query params from referrer to avoid leaking external PII
    let referrerOrigin: string | null = null;
    if (document.referrer !== "") {
      try {
        referrerOrigin = new URL(document.referrer).origin;
      } catch {
        referrerOrigin = null;
      }
    }

    const body = {
      category,
      action,
      page_url: route.path,
      referrer: referrerOrigin,
      screen_w: window.innerWidth,
      screen_h: window.innerHeight,
      utm_source:
        (route.query.mtm_source as string | undefined) ??
        (route.query.utm_source as string | undefined) ??
        null,
      utm_medium:
        (route.query.mtm_medium as string | undefined) ??
        (route.query.utm_medium as string | undefined) ??
        null,
      utm_campaign:
        (route.query.mtm_campaign as string | undefined) ??
        (route.query.utm_campaign as string | undefined) ??
        null,
    };

    $api().v2.tracking.create(body).catch(() => {
      // Background operation — silent failure per ADR-028
    });
  }

  return { trackEvent };
}
